import { render } from "./PrintDocument.vue?vue&type=template&id=8c28ea34&scoped=true"
import script from "./PrintDocument.vue?vue&type=script&lang=js"
export * from "./PrintDocument.vue?vue&type=script&lang=js"

import "./PrintDocument.vue?vue&type=style&index=0&id=8c28ea34&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c28ea34"]])

export default __exports__